interface Props {
  className?: string;
}
export const SuccessIcon = ({ className }: Props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="var(--swapper-success-color)"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ""}
    >
      <path d="M6.06683 10.0673L10.7668 5.36732L9.8335 4.43398L6.06683 8.20065L4.16683 6.30065L3.2335 7.23398L6.06683 10.0673ZM7.00016 13.6673C6.07794 13.6673 5.21127 13.4923 4.40016 13.1423C3.58905 12.7923 2.8835 12.3173 2.2835 11.7173C1.6835 11.1173 1.2085 10.4118 0.858496 9.60065C0.508496 8.78954 0.333496 7.92287 0.333496 7.00065C0.333496 6.07843 0.508496 5.21176 0.858496 4.40065C1.2085 3.58954 1.6835 2.88398 2.2835 2.28398C2.8835 1.68398 3.58905 1.20898 4.40016 0.858984C5.21127 0.508984 6.07794 0.333984 7.00016 0.333984C7.92238 0.333984 8.78905 0.508984 9.60016 0.858984C10.4113 1.20898 11.1168 1.68398 11.7168 2.28398C12.3168 2.88398 12.7918 3.58954 13.1418 4.40065C13.4918 5.21176 13.6668 6.07843 13.6668 7.00065C13.6668 7.92287 13.4918 8.78954 13.1418 9.60065C12.7918 10.4118 12.3168 11.1173 11.7168 11.7173C11.1168 12.3173 10.4113 12.7923 9.60016 13.1423C8.78905 13.4923 7.92238 13.6673 7.00016 13.6673Z" />
    </svg>
  );
};
